import { CustomSelect } from "@UI/CustomSelect"
import CustomTable from "@UI/CustomTable/CustomTable"

export const tabsCollectionAdministrationItems = ({
    handleChangeTable,
    statusItems = [],
    getInitialData,
    columns,
    loadingCollectionAdministrationTable,
    collectionAdministrationTable
}) => {
    return [
        {
            label: 'TODOS',
            key: 'all',
            children:
                (<div style={{ marginTop: '24px' }}>
                    <CustomSelect
                        allowClear={true}
                        width="250px"
                        placeholder={'Estado'}                        
                        onChange={(value) => getInitialData({ charge_status_id: value })}
                        options={statusItems}
                    />
                    <CustomTable
                        className="custom-table-variant-1"
                        loading={loadingCollectionAdministrationTable}
                        rowKey={'id'}
                        columns={columns}
                        dataSource={collectionAdministrationTable.dataTable}
                        onChange={handleChangeTable}
                        pagination={{
                            pageSize: collectionAdministrationTable.metadata.limit,
                            total: collectionAdministrationTable.metadata.quantity,
                            defaulPageSize: collectionAdministrationTable.metadata.limit,
                            current: collectionAdministrationTable.currentPage,
                            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                            position: ["bottomRight"]
                        }}
                    />
                </div>)
        },
        {
            label: 'PAPELERA',
            key: 'deleted',
            children:
                (<div style={{ marginTop: '24px' }}>
                    <CustomTable
                        className="custom-table-variant-1"
                        loading={loadingCollectionAdministrationTable}
                        rowKey={'id'}
                        columns={columns}
                        dataSource={collectionAdministrationTable.dataTable}
                        onChange={handleChangeTable}
                        pagination={{
                            pageSize: collectionAdministrationTable.metadata.limit,
                            total: collectionAdministrationTable.metadata.quantity,
                            defaulPageSize: collectionAdministrationTable.metadata.limit,
                            current: collectionAdministrationTable.currentPage,
                            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                            position: ["bottomRight"]
                        }} />
                </div>),
        },
    ]
}